"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const filtrarOrdenar_1 = require("../simpleGrid/filtrarOrdenar");
const header_1 = require("./header");
const table_1 = require("./table");
const keautils_1 = require("keautils");
const keautils_2 = require("keautils");
class GridTableFiltro extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.effectiveColumns = (props) => props.effectiveColumns;
        this.columnHeaderSelector = keautils_1.createSelector(this.effectiveColumns, cols => keautils_2.mapObject(cols, header_1.gridColumnToHeader));
        this.itemsSelector = (props) => props.items;
        this.filtroOrdenSelector = (props) => props.gridState.filtroOrden;
        this.itemsFiltroData = (props) => props.items;
        this.filtroOrdenColumnsSelector = (props) => props.filtroOrdenColumnas;
        this.itemsFiltradosSelector = keautils_1.createSelector(this.itemsFiltroData, this.filtroOrdenSelector, this.filtroOrdenColumnsSelector, (items, orden, columns) => filtrarOrdenar_1.filtrarOrdenar(items, orden, columns));
        this.mappingOrig = (props) => props.gridState.mapping;
        //El mappingOrig es un arreglo que esta cambiando, por eso lo comparamos deep para que ne caso de que los elemento del arreglo sean los mismos, no cambie el valor resultande del selector
        this.mapping = keautils_1.createDeepSelector(this.mappingOrig, x => x);
        this.mappedColumns = keautils_1.createSelector(this.effectiveColumns, this.mapping, (cols, mapping) => mapping.map(key => cols[key]));
    }
    render() {
        const items = this.itemsFiltradosSelector(this.props);
        const props = this.props;
        //Cabecera del grid, que es capaz de editar el filtro orden 
        const header = React.createElement(header_1.GridHeaderComponent, { columnas: this.columnHeaderSelector(this.props), value: this.props.gridState, onChange: this.props.onGridStateChange, puedeQuitar: this.props.puedeQuitarColumnas });
        return (React.createElement(table_1.GridTable, { columns: this.mappedColumns(this.props), getKey: props.getKey, header: header, items: items, onChange: props.onGridStateChange, sharedData: props.sharedProps, value: props.gridState, loading: props.loading, overflow: props.overflow }));
    }
}
exports.GridTableFiltro = GridTableFiltro;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/components/tableFiltro.js
// module id = 2228
// module chunks = 0